// How a file should be presented in the viewer, routed on the filename
// extension. `pdf`/`image` render inline; `office` (and anything unrecognised)
// falls back to Download. MIME-based routing would be more robust but most
// callers only have the original filename to hand.
export type ViewableKind = 'pdf' | 'image' | 'office';

export function viewableKind(fileName: string, mimeType?: string | null): ViewableKind {
  if (mimeType === 'application/pdf') return 'pdf';
  if (mimeType?.startsWith('image/') === true) return 'image';
  const name = fileName.toLowerCase();
  if (name.endsWith('.pdf')) return 'pdf';
  if (/\.(png|jpe?g|gif|webp)$/.test(name)) return 'image';
  return 'office';
}
